import { Type } from 'class-transformer';
import { PaginatedEntity } from '@core/entities';
import { SafeUrl } from '@angular/platform-browser';

export class UserContentTaskList extends PaginatedEntity {
  @Type(() => UserContentTaskEntity)
  tasks: UserContentTaskEntity[];
}

export class UserContentTaskEntity {
  id: number;
  title: string;
  description: string;

  // For Ui use only
  imageUrl: string | SafeUrl;
}
